import React from "react";
import { getFlagUrl } from "./Utils/getFlagUrl";

const OmniumRacesMobile = ({ data, boldRows, rowRange }) => {
  const isSpacer = (row) => row.every((cell) => !cell || cell.trim() === "");

  const renderRiderRow = (row, index) => {
    const rowNumber = rowRange[0] + index + 1;
    const isBold = boldRows.includes(rowNumber);
    const rank = row[0] || "";
    const lastName = row[2] || "";
    const firstName = row[3] || "";
    const country = row[4] || "";
    const points = row[5] || ""; // Om. Points or Total Points, depending on sheet

    return (
      <div key={index} className={`sqm-row ${isBold ? "bold-row" : ""}`}>
        <div className="sqm-rank">{rank}</div>
        <div className="sqm-left">
          <div className="sqm-last-name">{lastName}</div>
          <div className="sqm-first-name">{firstName}</div>
        </div>
        <div className="sqm-right">
          <img src={getFlagUrl(country)} alt={country} className="flag-icon" />
          <div className="sqm-time">{points}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="mobile-omnium">
      {data.map((row, index) => {
  const isHeaderRow = row[0]?.toLowerCase() === "rnk" || row[3]?.toLowerCase() === "last name";
  if (isSpacer(row) || isHeaderRow) return null;
  return renderRiderRow(row, index);
})}


        
      
    </div>
  );
};

export default OmniumRacesMobile;
